import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';
import { QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

export const successMeasurePropType = IPT.contains({
  id: PT.number.isRequired,
  description: PT.string.isRequired,
  color_code: PT.string.isRequired,
  guiding_question_text: PT.string.isRequired,
});

export const quizQuestionPropType = IPT.contains({
  id: PT.number.isRequired,
  text: PT.string.isRequired,
  answer_type: PT.string.isRequired,
  marks_available: PT.number,
  instructions: PT.string,
  more_instructions: PT.string,
  marking_prompt: PT.string,
  question_to_review: PT.number,
  indicated_maximum_marks: PT.number.isRequired,
  answers: IPT.listOf(
    IPT.contains({
      id: PT.number.isRequired,
      text: PT.string.isRequired,
      sort_order: PT.number.isRequired,
      is_correct: PT.bool.isRequired,
    })
  ),
  textarea_height: PT.number.isRequired,
});

export const chunkVisitPropType = IPT.contains({
  chunk: PT.number.isRequired,
  visitCount: PT.number.isRequired,
});

export const attachmentPropType = IPT.contains({
  id: PT.number.isRequired,
  attachment_type: PT.string.isRequired,
  title: PT.string.isRequired,
  url: PT.string,
  filename: PT.string,
});

export const chunkPropType = IPT.contains({
  id: PT.number.isRequired,
  title: PT.string.isRequired,
  title_with_knowledge_unit_serial: PT.string.isRequired,
  slug: PT.string.isRequired,
  position: PT.number.isRequired,
  is_first_in_lesson: PT.bool.isRequired,
  index: PT.number.isRequired,
  group_with_last: PT.bool.isRequired,
  youtube_url: PT.string,
  url: PT.string.isRequired,
  share_url: PT.string.isRequired,
  video: PT.object,
  notes: PT.string,
  more_notes: PT.string,
  question: quizQuestionPropType,
  activity: PT.number,
  knowledge_units: IPT.listOf(PT.number).isRequired,
  knowledge_units_read_only: IPT.listOf(
    IPT.contains({
      id: PT.number.isRequired,
      title: PT.string.isRequired,
      full_serial: PT.string.isRequired,
      difficulty: PT.number.isRequired,
    })
  ).isRequired,
  teaching_guide: PT.string,
  success_measure: successMeasurePropType,
  pdf_url: PT.string,
});

export const lessonPropType = IPT.contains({
  id: PT.number.isRequired,
  lft: PT.number.isRequired,
  title: PT.string.isRequired,
  slug: PT.string.isRequired,
  url: PT.string.isRequired,
  share_url: PT.string.isRequired,
  course_page_url: PT.string.isRequired,
  description: PT.string.isRequired,
  key_knowledge_text: PT.string.isRequired,
  is_published: PT.bool.isRequired,
  is_coming_soon: PT.bool.isRequired,
  is_premium: PT.bool.isRequired,
  parent: PT.number.isRequired,
  course: PT.number.isRequired,
  course_title: PT.string.isRequired,
  course_layout: PT.string.isRequired,
  syllabus_id: PT.number.isRequired,
  group_title: PT.string.isRequired,
  group_with_previous: PT.bool.isRequired,
  wistia_section_title: PT.string.isRequired,
  wistia_course_project_hashed_id: PT.string.isRequired,
  intro_wistia_hash: PT.string.isRequired,
  attachments: IPT.listOf(attachmentPropType).isRequired,
  chunks: IPT.listOf(chunkPropType).isRequired,
  lesson_type: PT.string.isRequired,
});

export const quizAttemptPropType = IPT.contains({
  id: PT.number,
  question: PT.number,
  reviewed_question_attempt: PT.number,
  is_correct: PT.bool,
  answer: PT.oneOfType([PT.number, PT.string]),
  answer_type: PT.oneOf(Object.values(QUESTION_TYPES)),
  submitted_answers: IPT.listOf(PT.number),
  user: PT.number,
  attempted_ts: PT.string,
  meta: PT.any,
});
